"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsElementOnHOverStyles = exports.CmsElementStyles = void 0;
exports.CmsElementStyles = [
    { attr: 'fontSize', suffix: 'px' },
    { attr: 'borderColor', prefix: '1px solid ', styleName: 'border' },
    { attr: 'bgColor', styleName: 'backgroundColor' },
    { attr: 'color' },
    { attr: 'width', suffix: 'px' },
    { attr: 'height', suffix: 'px' },
    { attr: 'top', suffix: 'px' },
    { attr: 'left', suffix: 'px' },
    { attr: 'lineHeight', suffix: 'px' },
    { attr: 'align', styleName: 'textAlign' },
    { attr: 'zIndex' },
    { attr: 'topPadding', suffix: 'px', styleName: 'paddingTop' },
    { attr: 'leftPadding', suffix: 'px', styleName: 'paddingLeft' },
    { attr: 'rotate', prefix: 'rotate(', styleName: 'transform', suffix: 'deg)' },
];
exports.CmsElementOnHOverStyles = [
    { attr: 'colorOnHover', styleName: 'color' },
    { attr: 'bgColorOnHover', styleName: 'backgroundColor' },
    { attr: 'borderColorOnHover', prefix: '1px solid ', styleName: 'border' },
];
//# sourceMappingURL=CmsElementCommon.js.map